import { isResaleActive } from "./shipment.core";
import { getCurrencyCode } from "./appCore";
import { REFUND_OPTIONS } from "../constants";

export function getRefundOptionType(refundOption) {
    return refundOption?.type;
}

export function getRefundGiftCardBonus(refundOption) {
    return refundOption?.bonusPercentage;
}

export function isRefundOptionGiftCard(refundOption) {
    return refundOption.type === REFUND_OPTIONS.GIFT_CARD;
}

export function getRefundOptionHeader(refundOption, { appProps }) {
    const bonusPercentage = getRefundGiftCardBonus(refundOption);
    return appProps?.getLocaleText(
        [
            "confirmation-page.refund-options",
            getRefundOptionType(refundOption),
            isResaleActive(appProps) ? "header-resale" : isRefundOptionGiftCard(refundOption) && !bonusPercentage ? "header-no-bonus" : "header",
        ],
        {
            ...refundOption,
            currencyCode: getCurrencyCode(appProps),
            bonusPercentage: bonusPercentage * 100,
        },
    );
}
